import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { groupByProperty } from '../../utils/collections';
import { getSearchParams } from '../../utils/url';
import { parseStringToInt } from '../../utils/parsing';
import { Page, Row, Fill } from '../util/Page';
import ChangelogFilters from '../util/ChangelogFilters';
import useDatedBuildings from '../util/dated-buildings';
import { filterBuildings } from '../../redux/selectors/buildings';
import DashboardRefresher from './DashboardRefresher';
import IngestPointStatus from './IngestPointStatus';
import DataQualityWidget from './DataQualityWidget';
import DataTermsInfo from './DataTermsInfo';
import PointIngestTimeseries from './graphs/PointIngestTimeseries';

const Dashboard = ({ buildingId, buildingsById, latestTimestamps, navigate, location }) => {
  // eslint-disable-next-line no-unused-vars
  const [filters, setFilters, resetFilters] = useDatedBuildings({ buildingId });
  const buildings = filterBuildings(buildingsById, filters).filter(
    (bid) => !!latestTimestamps[bid]
  );
  const setUrlAndFilters = (newFilters) => {
    const params = new URLSearchParams();
    newFilters.buildings.forEach((bid) => params.append('bid', bid));
    navigate(`${location.pathname}?${params.toString()}`);
    setFilters(newFilters);
  };
  return (
    <div style={{ display: 'grid' }}>
      <Page name="dashboard">
        <Row>
          <Typography variant="h6">Ingest Dashboard</Typography>
          <DashboardRefresher buildings={buildings} date={filters.date} />
          <Fill />
          <ChangelogFilters filters={filters} setFilters={setUrlAndFilters} noun="Ingests" />
        </Row>
      </Page>
      <Page end={12} grow={2}>
        <Row>
          <Typography variant="subtitle1">Ingests</Typography>
        </Row>
        <PointIngestTimeseries buildings={buildings} />
      </Page>
      <Page start={12} end={13}>
        <Row>
          <Typography variant="subtitle1">Data Quality</Typography>
          <Fill />
          <DataTermsInfo />
        </Row>
        <DataQualityWidget buildings={buildings} />
      </Page>
      <Page>
        <Row>
          <Typography variant="subtitle1">Latest Ingest Activity</Typography>
        </Row>
        <IngestPointStatus buildings={buildings} />
      </Page>
    </div>
  );
};

export default connect(
  (
    {
      user: { orgId },
      entities: {
        buildings: { byId },
        ingestStats: { latestTimestamps },
      },
    },
    { location: { search } }
  ) => {
    const { bid } = getSearchParams(search);
    return {
      buildingId: parseStringToInt(bid),
      buildingsById: groupByProperty(
        'id',
        Object.values(byId).filter((b) => b.orgId === orgId)
      ),
      latestTimestamps,
    };
  }
)(Dashboard);
